var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCriticalRiskIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.035 23.625c-1.178 0-2.346-.346-3.264-1.027l-4.649-4.032c-1.232-.92-2.194-2.844-2.194-4.368v-7.48c0-1.665 1.221-3.438 2.789-4.022L10.11.675c1.07-.4 2.757-.4 3.827 0l5.394 2.021c1.568.584 2.79 2.357 2.79 4.022v7.47c0 1.534-.963 3.448-2.195 4.367l-4.649 4.032c-.897.692-2.064 1.038-3.243 1.038Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E45C51",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M11.995 6.3v6.667"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E45C51",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5,
    d: "M11.987 16.967H12"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCriticalRiskIcon);
export default __webpack_public_path__ + "static/media/critical-risk-icon.7a5c674109e1d180fb89512dc6e176e9.svg";
export { ForwardRef as ReactComponent };